import get from 'lodash/get';
import { getConfig } from './portal';
import { getMessages } from '../tppServices/translations/messages';


const isUppercase = (word) => word === word.toUpperCase();

const getProductsConfig = (config) => {
  const productsConfig =  config || getConfig();
  return productsConfig?.pages?.products || {};
};

export const getProductConfigByKey = (productKey, config) => {
  const productsConfig = getProductsConfig(config);
  return productsConfig?.[productKey] || {};
};

export const getProductConfigByPathIndex = (pathIndex, config) => {
  const productsConfig = getProductsConfig(config);
  const pathToProductMap = [];

  // Build mapping of path indices to product keys
  for (const [productKey, productConfig] of Object.entries(productsConfig)) {
    if (productConfig.route) {
      pathToProductMap.push(productKey);
    }
  }

  const productKey = pathToProductMap[pathIndex];
  const productConfig = getProductConfigByKey(productKey, config);

  return { productKey, productConfig };
};

export const generateProductPaths = (routesConstants, intl, config) => {
  const productsConfig = getProductsConfig(config);
  const paths = [];

  const t = intl.formatMessage;
  const messages = getMessages();

  for (const [, config] of Object.entries(productsConfig)) {
    if (config.route) {
      let route = config.route;
      // search for placeholders {{key}}
      const placeholderRegex = /\{\{([^}]+)\}\}/g;

      route = route.replace(placeholderRegex, (match, key) => {
        const translation = isUppercase(key) ? routesConstants[key] : t(get(messages, key));

        if (translation) {
          return translation;
        }
        return match;
      });
      paths.push(route);
    }
  }

  return paths;
};
